module.exports = __webpack_public_path__ + "img/Slide001.166fe987.jpg";